import './customInput.css';

function CustomInput(props) {
  const { placeholder, type, value } = props;
  return (
    <div className="customInput">
      <input placeholder={placeholder} type={type} value={value} />
    </div>
  );
}

export default CustomInput;
